import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { AspectRatioRounded } from '@mui/icons-material';
import { Edit } from '../../constructor/work/Edit';
import { useHandlerNotificationApp } from '../../hooks/useHandlerNotificationApp';

export const ButtonAddScale = () => {
  const { addNotification } = useHandlerNotificationApp();
  const [isObjectScale, setIsObjectScale] = useState(!Edit.setScaleObject);
  const handleButtonScale = () => {
    if (Edit.drawingSubstrate) {
      if (Edit.setScaleObject) {
        Edit.removeSetScaleObject();
        setIsObjectScale(true);
      } else {
        Edit.addSetScaleObject();
        setIsObjectScale(false);
      }
    } else {
      addNotification({
        messageError: 'Для масштабирования необходимо добавить подложку.',
        typeMessage: 'info',
      });
    }
  };

  return (
    <>
      <Box width="100%" mb="20px">
        <Button
          fullWidth
          variant="outlined"
          startIcon={<AspectRatioRounded />}
          onClick={handleButtonScale}
          sx={{
            '&': {
              border: '1px solid #97A408',
              borderRadius: '10px',
              height: '50px',
              color: '#fff',
            },
          }}
        >
          <Typography color="#e5e5e5" fontSize="14px">
            {!isObjectScale ? 'Удалить' : 'Масштабировать'}
          </Typography>
        </Button>
      </Box>
    </>
  );
};
